<template>
    <div class="c-app">
      <div class="container">
        <div id="btn-open-caja" class="d-flex justify-content-end pt-2 mt-3">
            <div class="btn-group btn-home me-2">
                <button type="button" class="btn btn-outline-main bg-main text-white" @click="mtdBackCampus">
                    <i class="fas fa-recycle"></i> Cambiar de Sede
                </button>
            </div>
        </div>
        <div class="row px-3 mt-5" id="div_conte2">
            <div id="div_conte" class="col-md-10 mx-auto">
                <div class="bg-secondary text-white bg-opacity-10">
                    <div class="text-center py-3 px-5 btn-home" id="scroll-div">
                        <div class="row mt-2">
                            <button class="border-0  rounded-3 col m-2 p-2 text-white" @click="changePage('recetas')">
                                <strong>RECETAS</strong>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="px-3 py-3">
            <Recetas :pa="pa"/>
        </div> -->
      </div>
    </div>
</template>

<script>
import Recetas from "@/components/Servicios/pages/Recipes.vue";
export default {
    name: 'homeFarmacia',
    data() {
        return {
            page: null,
            pa: 1,
        }
    },
    components: {
        Recetas
    },
    methods: {
        changePage(page) {
            this.$emit('changePage', page)
        },
        mtdBackCampus: function () {
            this.$emit('mtdBackCampus')
        },
        mtdCloseBead() {
            this.$emit("changePage", "reporteClose");
        }
    }
}
</script>

<style scoped>
@media (max-width: 415px) {
    #scroll-div {
        height: 140px;
    }
}
@media (max-width: 1024px) {
  #scroll-div {
    /*height: 200px;*/
    height: 140px;
  }
}
@media (max-width: 768px) {
  #scroll-div {
    /*height: 170px;*/
    height: 120px;
  }
}

</style>
